<template>
  <div v-loading="dataLoading" class="shareholder-box">
    <div class="shareholder-title">{{$t('message.user.shareholderInfo') + `（${$t('message.common.optional')}）`}}</div>
    <div class="shareholder-desc">{{$t('message.user.shareholderRequire')}}</div>
    <div class="shareholder-list">
      <div v-for="(item, index) in shareholderInfoList" :key="index" class="shareholder-item">
        <el-form label-position="top">
          <el-form-item :label="$t('message.user.shareholderName')">
            <div class="form-item-name">
              <el-input class="shareholder-name" v-model="item.name" :placeholder="$t('message.validator.input', { input: $t('message.user.shareholderNameInputTips')})"></el-input>
              <el-input
                class="shareholder-percent"
                v-model="item.shareholdingRatio"
                :placeholder="$t('message.user.shareholderRatioInputTips')"
                @change="handleRatioChange(index, $event)"></el-input>
              <span>%</span>
            </div>
          </el-form-item>
          <el-form-item :label="$t('message.user.shareholderMaterial')">
            <div class="material-box">
              <div class="material-tip">{{$t('message.user.uploadImageTips')}}</div>
              <div class="material-item" :class="[item.idCardFront ? 'dash-box' : '']">
                <RhcnUpload
                  :title="$t('message.user.pleaseUploadPortraitSide')"
                  :fileList="item.idCardFrontList"
                  :accept="'image/png,image/jpeg,image/jpg'"
                  :on-change="onMaterialItemChange(index, 'idCardFront')"
                  :on-remove="onMaterialItemRemove(index, 'idCardFront')">
                </RhcnUpload>
              </div>
              <div class="material-item" :class="[item.idCardReverse ? 'dash-box' : '']">
                <RhcnUpload
                  :title="$t('message.user.pleaseUploadNationalEmblemSide')"
                  :fileList="item.idCardReverseList"
                  :accept="'image/png,image/jpeg,image/jpg'"
                  :on-change="onMaterialItemChange(index, 'idCardReverse')"
                  :on-remove="onMaterialItemRemove(index, 'idCardReverse')">
                </RhcnUpload>
              </div>
            </div>
          </el-form-item>
          <el-form-item :label="$t('message.user.shareholderNumber')">
            <el-input v-model="item.idNumber" :maxlength="18" :placeholder="$t('message.validator.input', { input: $t('message.user.shareholderNumber').toLowerCase() })"></el-input>
          </el-form-item>
          <el-form-item :label="$t('message.user.shareholderNumberDate')">
            <div class="expire-box">
              <RhcnDatepicker v-model="item.effectiveDate"
                              :pickerOptions="pickerStartOptions"
                              type="date"
                              :format="'yyyy-MM-dd'">
              </RhcnDatepicker>
              <i class="el-icon-minus margin-left-3 margin-right-3" style="line-height: 32px"></i>
              <RhcnDatepicker v-model="item.expireDate"
                              type="date"
                              :pickerOptions="pickerEndOptions"
                              :disabled="item.longEffective"
                              :format="'yyyy-MM-dd'">
              </RhcnDatepicker>
              <div class="expire-long-box">
                <el-checkbox v-model="item.longEffective" @change="handleLongEffective(index, $event)"></el-checkbox>
                <span class="margin-left-10">{{$t('message.user.longEffective')}}</span>
              </div>
            </div>
          </el-form-item>
        </el-form>
        <div class="operate-box">
          <div v-if="shareholderInfoList.length > 1" class="operate-item" @click="handleRemove(index)">
            <span class="el-icon-minus"></span>
            <span>{{$t('message.user.deleteShareholder')}}</span>
          </div>
          <div v-if="((index + 1) === shareholderInfoList.length) && shareholderInfoList.length < 10" class="operate-item" @click="handleAdd">
            <span class="el-icon-plus"></span>
            <span>{{$t('message.user.addShareholder')}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="margin-top-20">
      <el-button
      style="width: 100%"
      type="primary"
      @click="onSubmit"
      >{{ $t("message.common.next") }}</el-button>
      <!-- <div class="btn-jump" @click="onJump">{{$t('message.common.jump')}}</div> -->
    </div>
  </div>
</template>

<script>
import RhcnDatepicker from '@/components/form/datepicker.vue';
import { ShowWarningMessage } from '@/components/modal/tips/message-tips';
import { formatDateDisplay } from '@/utils/tools/time';
import { shallowClones } from '@/utils/tools/utils';
import RhcnUpload from '@/views/account/information/supplement/upload/index.vue';
import { uploadMaterialUseTemplate } from '@/views/transfer/api/contact';

export default {
  components: {
    RhcnDatepicker,
    RhcnUpload,
  },
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dataLoading: false,
      shareholderInfoList: [{}],
      pickerStartOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      pickerEndOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
    };
  },
  mounted() {
    if (this.info.shareholderInfoList && this.info.shareholderInfoList.length > 0) {
      this.shareholderInfoList = this.info.shareholderInfoList.map(item => {
        const data = shallowClones(item);
        const longEffective = data.expireDate === '2099-01-01';
        data.longEffective = longEffective;
        if (longEffective) {
          data.expireDate = '';
        }
        return data;
      });
    }
  },
  methods: {
    handleLongEffective(index, value) {
      if (value) {
        this.shareholderInfoList[index].expireDate = '';
      }
    },
    onMaterialItemChange(index, key) {
      return async (event, array) => {
        if (event.name) {
          const fileName = event.name;
          const fileNameArr = fileName.split('.');
          const ext = fileNameArr[fileNameArr.length - 1].toLowerCase();
          const extList = ['png', 'jpg', 'jpeg', 'bmp'];
          if (extList.indexOf(ext) === -1) { // 不支持格式， 处理兼容性问题
            ShowWarningMessage(this.$t('message.supportFileErrorTip', { type: extList.join(',') }));
            throw new Error(this.$t('message.supportFileErrorTip', { type: extList.join(',') }));
          }
        }
        this.dataLoading = true;
        try {
          const res = await uploadMaterialUseTemplate(event.raw);
          this.shareholderInfoList[index][`${key}`] = res;
          this.shareholderInfoList[index][`${key}List`] = [{
            name: event.name,
            url: res,
          }];
        } catch (err) {
        }
        this.dataLoading = false;
      };
    },
    onMaterialItemRemove(index, key) {
      return async () => {
        this.shareholderInfoList[index][`${key}`] = '';
        this.shareholderInfoList[index][`${key}List`] = [];
      };
    },
    handleAdd() {
      this.shareholderInfoList.push({});
    },
    handleRemove(index) {
      this.shareholderInfoList.splice(index, 1);
    },
    handleRatioChange(index, value) {
      let v = value.replace(/^(0+)|[^\d]+/g, '');
      if (!v) {
        return;
      }
      if (+v < 10) {
        v = 10;
      } else if (+v > 100) {
        v = 100;
      }
      this.shareholderInfoList[index].shareholdingRatio = v;
    },
    isEmptyData(data = {}) {
      if (!data) {
        return true;
      }
      const keys = Object.keys(data);
      for (let i = 0; i < keys.length; i++) {
        const k = keys[i];
        if (data[k]) {
          return false;
        }
      }
      return true;
    },
    async submit() {
      return new Promise((resolve) => {
        const list = [];
        this.shareholderInfoList.forEach(item => {
          if (!this.isEmptyData(item)) {
            if (item.longEffective) {
              item.expireDate = '2099-01-01';
            } else if (item.expireDate) {
              item.expireDate = formatDateDisplay(item.expireDate, 'yyyy-MM-dd');
            }
            if (item.effectiveDate) {
              item.effectiveDate = formatDateDisplay(item.effectiveDate, 'yyyy-MM-dd');
            }
            list.push(item);
          }
        });
        resolve({ shareholderInfoList: list });
      });
    },
    async onSubmit() {
      try {
        const res = await this.submit();
        this.$emit('finish', res);
      } catch (err) {
      }
    },

    onJump() {
      this.$emit('finish', { shareholderInfoList: [] });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/element-variables.scss';
.shareholder-box {
  .shareholder-title {
    font-size: 14px;
    font-weight: 600;
    color: $color-text-primary;
    line-height: 32px;
  }

  .shareholder-desc {
    font-size: 14px;
    font-weight: 400;
    color: $color-text-primary;
    line-height: 32px;
  }

  .shareholder-list {
    margin-top: 6px;

    .shareholder-item {
      position: relative;
      border-top: 1px solid $color-font-disabled;
      border-bottom: 1px solid $color-font-disabled;

      ::v-deep .el-form {
        .el-form-item {
          .el-form-item__label {
            font-size: 14px;
            font-weight: 600;
            color: $color-text-primary;
            line-height: 32px;
          }
        }
      }

      .form-item-name {
        width: 100%;
        display: flex;
        align-items: center;
        .shareholder-name {
          width: 300px;
        }

        .shareholder-percent {
          width: 120px;
          margin-left: 10px;
          margin-right: 5px;
        }
      }

      .expire-box {
        display: flex;
        align-items: center;

        .rhcn-datepicker {
          width: 140px;
        }

        .expire-long-box {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 120px;
          height: 44px;
          background: $color-default;
          border-radius: 4px;
          margin-left: 30px;
        }
      }

      .material-box {
        .material-tip {
          font-size: 14px;
          font-weight: 400;
          color: #B7C4CE;
          line-height: 32px;
          white-space: nowrap;
        }
        .material-item {
          position: relative;
          margin-bottom: 15px;
          border: 1px solid transparent;

          &.dash-box {
            margin-top: 10px;
            &::before {
              content: '';
              position: absolute;
              top: -10px;
              left: -10px;
              width: 470px;
              height: 114px;
              border-radius: 4px;
              border: 1px dashed #B7C4CE;
              z-index: -1;
            }
          }

          ::v-deep .el-upload {
            width: 100%;
          }

          &:last-child {
            margin-bottom: 0;
          }
        }
      }

      .operate-box {
        position: absolute;
        bottom: 0;
        right: 0;

        .operate-item {
          position: absolute;
          bottom: 0;
          left: 44px;
          width: 100px;
          height: 100px;
          background: $color-default;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          font-size: 16px;
          font-weight: 800;
          color: $color-primary;
          line-height: 26px;

          &:nth-child(2) {
            left: 160px;
          }

          .el-icon-plus, .el-icon-minus {
            font-size: 30px;
          }
        }
      }
    }
  }

  .btn-jump {
    margin: 0 auto;
    font-size: 16px;
    font-weight: 600;
    color: $color-primary;
    line-height: 32px;
    text-align: center;
    cursor: pointer;
  }
}
</style>
